import { Box } from "@chakra-ui/react";
import styled from "@emotion/styled";
import { useQuery } from "@tanstack/react-query";
import useFetch from "lib/hooks/useFetch";
import Link from "next/link";
import React from "react";
import "swiper/css";
import "swiper/css/effect-fade";
import "swiper/css/pagination";
import { Autoplay, EffectFade, Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";

const StyledSwiper = styled(Swiper)`
  width: 376px;
  height: 123px;
  margin-left: auto;
  margin-right: auto;
  .swiper-pagination {
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    justify-content: center;
    width: 50px;
    bottom: 15%;
  }
  .swiper-pagination-bullet {
    background-color: white;
    flex-basis: 108px;
    margin: 0 !important;
    border-radius: 0px;
    &:first-child {
      border-radius: 4px 0px 0px 4px;
    }
    &:last-child {
      border-radius: 0px 4px 4px 0px;
    }
  }
  .swiper-slide {
    cursor: pointer;
  }
`;
const AdSwiper = () => {
  const fetchApi = useFetch();
  const { data, isLoading } = useQuery({
    queryKey: ["banner"],
    queryFn: () => fetchApi<any, any>("https://version.depaas.de/rest/banner/list?appId=2&showTerminalType=3&pageLocation=3"),
  });
  const banners = data?.data?.filter((b) => b.bannerType === 2);

  return (
    <StyledSwiper
      // onSwiper={setSwiperRef}
      modules={[Autoplay, Pagination, EffectFade]}
      // spaceBetween={50}
      observer
      slidesPerView={1}
      effect="fade"
      fadeEffect={{ crossFade: true }}
      speed={500}
      autoplay={{
        delay: 5000,
        pauseOnMouseEnter: true,
        disableOnInteraction: false,
      }}
      loop
      pagination={{ clickable: true }}
    >
      {banners?.map((banner) => (
        <SwiperSlide>
          <Link href={banner?.link} target="_blank">
            <Box rounded="lg" overflow="hidden">
              <img src={banner?.img} alt="" style={{ objectFit: "cover", width: "376px", height: "123px" }} />
            </Box>
          </Link>
        </SwiperSlide>
      ))}
      {/* <SwiperSlide>
        <Link href="https://deswap.finance/?chain=DEP" target="_blank">
          <Box rounded="lg" overflow="hidden">
            <img src="https://depaas-im.oss-accelerate.aliyuncs.com/apk/E1hb7s5FT57262566Rzl941BEG51T.png" alt="" style={{ objectFit: "cover", width: "376px", height: "123px" }} />
          </Box>
        </Link>
      </SwiperSlide> */}
      {/* <SwiperSlide>
        <Link href="https://deswap.finance/?chain=DEP" target="_blank">
          <Box rounded="lg" overflow="hidden">
            <img
              src="https://depaas-im.oss-accelerate.aliyuncs.com/apk/0n6111oE07q35Md6n7lC478fxQ727.png"
              alt=""
              style={{ objectFit: "cover", width: "376px", height: "123px" }}
            />
          </Box>
        </Link>
      </SwiperSlide> */}
    </StyledSwiper>
  );
};

export default AdSwiper;
